import React from "react";

import Link from "next/link";
import Image from "next/image";

import ArrowRight from "assets/iconsv2/arrow-right-16.svg";
import Grid from "assets/developers/developers-background-grid.png";

import Container from "components/Container";

import GlowyCallToAction from "components/GlowyCallToAction";

import styles from "./Hero.module.css";

const Hero: React.FC = () => {
  return (
    <div className={styles.hero}>
      <div className={styles.background}>
        <div className={styles.grid}>
          <Image src={Grid} layout="intrinsic" alt="a grid of lines" />
        </div>
      </div>
      <Container>
        <div className={styles.heroBody}>
          <h1>Build the perfect tools</h1>
          <p>
            Turn ordinary tools into magical extensions with our API and speed up your tasks. Leave the heavy lifting to
            us.
          </p>
          <GlowyCallToAction href="/users/sign_up">Create account</GlowyCallToAction>
          <span className={styles.alreadyHaveAnAccount}>
            Already have an account?{" "}
            <Link href="/users/sign_in">
              <a>
                Log in
                <ArrowRight />
              </a>
            </Link>
          </span>
        </div>
      </Container>
    </div>
  );
};

export default Hero;
